import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../../Components/firebase';
import { doc, getDoc } from 'firebase/firestore';

import PageHeader from '../../../Components/PageHeader';
import PostSection from './PostSection';
import MainCommentsSection from '../../../Components/Comments/MainCommentsSection';
import PromotedPanel from '../../../Components/ViewPosts/PromotedPanel';
import '../../../App.css';
import './DirectoryPost.css';
import GetPostRoute from "../../../Functions/GetPostRoute";
import { useRedirectMobile } from "../../../Hooks/useRedirectMobile";
import ViewRequestedQuotes from './ViewRequestedQuotes';

const DirectoryPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  useRedirectMobile(`/directorypostmobile/${id}`);
  const [loading, setLoading] = useState(true);
  const [postData, setPostData] = useState(null);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [addQuoteToCartHandler, setAddQuoteToCartHandler] = useState(null);

  useEffect(() => {
    const checkPostExists = async () => {
      setLoading(true);
      try {
        const postRef = doc(db, 'Posts', id);
        const postSnap = await getDoc(postRef);
        if (!postSnap.exists()) {
          console.warn('Post not found.');
          navigate("/home");
          return;
        }
        const post = postSnap.data();
        setPostData(post);
        if (post.type !== 'directory') {
          console.warn('Post not a directory post');
          const postRoute = GetPostRoute(post.type);
          if (postRoute) {
            navigate(postRoute + id);
          } else {
            navigate("/home");
          }
          return;
        }
      } catch (err) {
        console.error('Error fetching post:', err);
      } finally {
        setLoading(false);
      }
    };
    checkPostExists();
  }, [id, navigate]);

  if (loading)
    return <p style={{ color: 'white', textAlign: 'center' }}>Loading...</p>;

  return (
    <div className="vpe-content-page">
      <PageHeader 
        title="Directory Post" 
        backgroundUrl="https://assets.goaaa.com/image/upload/w_2880,c_fill,q_auto,f_auto/v1742591982/AAAGilbert-428_retouched.jpg" 
      />
      <PostSection 
        postId={id}
        selectedQuote={selectedQuote}
        setAddQuoteToCartHandler={setAddQuoteToCartHandler}
        />
      <ViewRequestedQuotes
        directoryPostId={id}
        sellerUserId={postData?.userId}
        onSelectQuote={setSelectedQuote}
        onAddQuoteToCart={addQuoteToCartHandler}
      />
      <div className="vpe-bottom-section-container">
        <div className="vpe-bottom-section-main-content">
          <MainCommentsSection postId={id} />
        </div>

        <div className="vpe-bottom-section-side-panel">
          <PromotedPanel category="directory" />
        </div>
      </div>
    </div>
  );
};

export default DirectoryPost;
